import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { GeneralService } from 'src/app/providers/general/general.service';
import { TimesheetService } from 'src/app/providers/timesheet/timesheet.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $: any;

@Component({
  selector: 'app-add-issue',
  templateUrl: './add-issue.component.html',
  styleUrls: ['./add-issue.component.scss']
})
export class AddIssueComponent implements OnInit {
  @Input() mdlId = 'issue_tracker'; 
  @Input() data:any = new Object({});
  Img: any = [];
  isEdit: boolean = false;
  issueTypeForm:FormGroup;
  appDropDown :any = [];
  submit = false;
  response: any = [];
  constructor(private generaServe: GeneralService,
    private  formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private timeSheet: TimesheetService,
    private router: Router) { 
      
      console.log(this.mdlId);
    }

  get issueErrorMsg() { return this.issueTypeForm.controls; }

 

  ngOnInit(): void {
    console.log(this.data);
    this.issueTypeFormFields();
    this.getApplications();
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log(this.data);
  if(Object.keys(this.data).length > 0){
    this.isEdit = true
    this.issueTypeForm.patchValue({
      app_id: this.data.app_id,
      issue_req_date: this.data.reqts_date,
      develop_by: this.data.develop_by,
      issue_desc: this.data.issue_desc,
      devlop_date: this.data.devlp_date,
      status: this.data.result,
      issue_owner: this.data.issue_owner
    });
  }else{
    this.isEdit = false;
  }
   
    console.log();
  }

  issueTypeFormFields(): void{
    this.issueTypeForm = this.formBuilder.group({
      app_id: ['', Validators.required],
      //issue_req_date: ['', Validators.required],
      priority: ['', Validators.required],
      develop_by: ['', Validators.required],
      issue_desc: ['', Validators.required],
      devlop_date: ['', Validators.required],
      status: ['', Validators.required],
      //issue_owner: ['',Validators.required],
      doc: ['']
    });

    if(this.mdlId == 'issue_tracker'){
      this.issueTypeForm.get('develop_by').setValidators([Validators.required]);
      this.issueTypeForm.get('develop_by').updateValueAndValidity();
      this.issueTypeForm.get('devlop_date').setValidators([Validators.required]);
      this.issueTypeForm.get('devlop_date').updateValueAndValidity();
      this.issueTypeForm.get('status').setValidators([Validators.required]);
      this.issueTypeForm.get('status').updateValueAndValidity();
    }else{
      this.issueTypeForm.get('develop_by').clearValidators();
      this.issueTypeForm.get('develop_by').updateValueAndValidity();
      this.issueTypeForm.get('devlop_date').clearValidators();
      this.issueTypeForm.get('devlop_date').updateValueAndValidity();
      this.issueTypeForm.get('status').clearValidators();
      this.issueTypeForm.get('status').updateValueAndValidity();
    }
  }

  closeModal(): void{
    this.submit = false;
    this.issueTypeForm.reset();
    $(`#${this.mdlId}`).modal('hide');
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.Img = file;
    }
  }

  onSubmitIssue(): void{
    this.submit = true;
    if(this.issueTypeForm.invalid)
    {
      return;
    }

    const issueTypeForm = new FormData();
    issueTypeForm.append('image',this.Img);
    issueTypeForm.append('app_id',this.issueTypeForm.get('app_id').value);
    //issueTypeForm.append('issue_req_date',this.issueTypeForm.get('issue_req_date').value);
    issueTypeForm.append('priority',this.issueTypeForm.get('priority').value);
    issueTypeForm.append('develop_by',this.issueTypeForm.get('develop_by').value);
    issueTypeForm.append('issue_desc',this.issueTypeForm.get('issue_desc').value);
    issueTypeForm.append('devlp_date',this.issueTypeForm.get('devlop_date').value);
    issueTypeForm.append('status',this.issueTypeForm.get('status').value);
    //issueTypeForm.append('issue_owner',this.issueTypeForm.get('issue_owner').value);

    if(this.isEdit){
      issueTypeForm.append('time_id',this.data.id);
      this.timeSheet.updateIssueTracker(issueTypeForm).subscribe(res => {
        this.submit = false;
        if (res.status) {
          this.notifyService.showSuccess(res.msg, 'Success!');
          window.location.reload();
         this.closeModal();
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
        }
       
      }, err => {
        this.submit = false;
        this.notifyService.showError('Internal Server Error', 'Error!');
      });

    }else{

      this.timeSheet.addIssueTracker(issueTypeForm).subscribe(res => {
        this.submit = false;
        if (res.status) {
          this.notifyService.showSuccess(res.msg, 'Success!');
          //window.location.reload();
         this.closeModal();
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
        }
       
      }, err => {
        this.submit = false;
        this.notifyService.showError('Internal Server Error', 'Error!');
      });
    }
    
     
  }

  getApplications(): void {
    this.generaServe.getActiveApplication().subscribe(res => {
      this.response = res;
      if (this.response.status) {
        this.appDropDown = this.response.data;
      } else {
        this.notifyService.showInfo(this.response.msg, 'Info!');
      }
    });
  }

  viewHistory(): void{
    this.router.navigate(['/timesheet'])
  }

}
